import React, { Dispatch, useContext, useEffect, useMemo, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { DateChoiceModel, SpecificationsDepositModel } from '../../../requestsModel'
import { MakeRequestContext } from '../../MakeRequestContext'
import { connect, useDispatch, useSelector } from 'react-redux'
import errorCatcher from '../../../../../utils/errorCatcher'
import fetchFactory from '../../../../../utils/fetchFactory'
import { configEnum } from '../../../../../enums/fetchFactoryEnum'
import arrayMutators from 'final-form-arrays'
import { Field, Form } from 'react-final-form'
import Loader from '../../../../../components/loader/Loader'
import Button from '../../../../../components/button/Button'
import { Grid, MenuItem, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../../../styles'
import { formFieldsEnum } from './enums/formFieldsEnum'
import FormDatePickerField from '../../../../../components/fields/FormDatePickerField'
import { getToday } from '../../../../../utils/getDays/getToday'
import portals from '../../../../../enums/portalsEnum'
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date'
import classNames from 'classnames'
import FormTextField from '../../../../../components/fields/FormTextField'
import FormRadioField from '../../../../../components/fields/FormRadioField'
import { OnChange } from 'react-final-form-listeners'
import { useMediaQuery } from 'react-responsive'
import { FieldArray } from 'react-final-form-arrays'
import DateTimeSlotSelect from '../step4/DateTimeSlotSelect'
import FormSelectField from '../../../../../components/fields/FormSelectField'
import selectColorEnum from '../../../../../enums/selectEnums/SelectColorEnum'
import selectSizeEnum from '../../../../../enums/selectEnums/SelectSizeEnum'
import { leaveReasonApartmentEnum, leaveReasonBothEnum, leaveReasonCampusEnum, leaveReasonParkingEnum } from './enums/leaveReasonEnum'
import { ClassValue } from 'classnames/types'
import { categoriesJuridiquesCodeCivil, PRL_AUTO, propertyType, TIP } from '../../../../../enums/contractsEnum'
import FormFile from '../../../../../components/fields/FormFile'
import CheckBoxField from '../../../../../components/fields/CheckBoxField'
import { RootState } from '../../../../reducers'
import { AccessibilityModel } from '../../../../../types/accessibility/accessibilityModel'
import ROLE from '../../../../../enums/interlocuteurRoleEnum'
import moment from 'moment'
import { displaySnackbar } from '../../../../reducers/snackBar/actions'
import FormPhoneField from '../../../../../components/fields/FormPhoneField'
import { FORM_ERROR } from 'final-form'
import { FormErrorEnum } from '../../../../../enums/errorsTypeEnum'
import { getNextYearDate } from '../../../../../utils/getDays/getNextYearDate'
import { getNextAvailableDay, shouldBlockCalendarDay } from '../../../../../utils/getDays/datePickerUtils'
import { getJoursFeries } from './api/getJoursFeries'

const useStyles = makeStyles<Theme, { isLargeScreen: boolean, accessibility: AccessibilityModel }>(
    (theme) => (
        {
            ...styles(theme),
            formStyle: {
                marginBottom: 20
            },
            buttonContainer: {
                marginTop: 50
            },
            dateText: {
                fontSize: 18,
                fontWeight: 500,
                color: theme.palette.blue.main,
                opacity: 0.7,
                lineHeight: 1.33
            },
            timeSlotContainer: {
                paddingTop: '5%',
                paddingBottom: '5%'
            },
            textNotSelected: {
                color: theme.palette.blue['50']
            },
            commonLabel: {
                marginBottom: 10
            },
            informationStyle: {
                whiteSpace: 'pre-line',
                marginTop: 85
            },
            mainInformationStyle: {
                marginTop: 20,
                marginBottom: 50,

				'& ul': {
					listStyle: props => props.accessibility.isVisualHandicap ? 'url("img/listIconBlue.svg")' : 'url("img/listIcon.svg")'
				},
				'& ol': {
					listStyle: 'auto',
					marginTop: 15,
					marginBottom: 15,

                    '& li::marker': {
                        color: theme.palette.accessibility.main
                    }
                },
                '& span, & li': {
                    ...styles(theme).text3,
                    fontSize: props => props.isLargeScreen ? 16 : 14
                }
            }
        }
    )
)

const COMPONENT_NAME: string = 'requestSpecificationsError'

const RequestSpecificationsDeposit = () => {
	const accessibility = useSelector((state: RootState) => state.accessibility)
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)
	const classes = useStyles({ isLargeScreen, accessibility })
	const intl = useIntl()
	const { request, nextStep } = useContext(MakeRequestContext)
	const user = useSelector((state: RootState) => state.user)
	const [loading, setLoading] = useState<boolean>(false)

	const inputText = classNames(
		isLargeScreen ? classes.text8 : classes.text14,
		classes.colorBlue,
		classes.semiBold
	)

	const textSelect = classNames(
		classes.text8,
		classes.textNotSelected
	)

	const commonLabel: ClassValue = classNames(
		classes.text5,
		classes.colorBlue,
		classes.commonLabel
	)

	const informationClass = classNames(
		isLargeScreen ? classes.text11 : classes.text18,
		classes.colorBlue,
		classes.informationStyle
	)

	const mainInformationClass = classNames(
		classes.colorBlue,
		classes.mainInformationStyle
	)

    const errorClass: ClassValue = classNames(
        classes.text1,
        classes.errorStyle
    )

    const choice1: string = intl.formatMessage({
        id: 'requests.makeRequest.step4.deposit.datesOption',
        defaultMessage: 'Je sélectionne 3 dates',
        description: 'choice date'
    })
    const choice2: string = intl.formatMessage({
        id: 'requests.makeRequest.step4.deposit.advisorOption',
        defaultMessage: 'Je préfère me faire contacter par un conseiller',
        description: 'choice advisor'
    })
    const defaultDate: string = intl.formatMessage({
        id: 'requests.makeRequest.step4.dateText',
        defaultMessage: 'Date',
        description: 'text date in select'
    })
    const defaultTimeSlot: string = intl.formatMessage({
        id: 'requests.makeRequest.step4.timeSlotText',
        defaultMessage: 'Créneau',
        description: 'text timeSlot in select'
    })

	const isAlone: string = intl.formatMessage({
		id: 'requests.makeRequest.step4.deposit.isAlone',
		defaultMessage: 'Je suis seul à quitter l\'appartement, et ce congé est donc adressé en mon nom seul',
		description: 'Is alone radio button'
	})
	const hasCopreneurs: string = intl.formatMessage({
		id: 'requests.makeRequest.step4.deposit.hasCopreneurs',
		defaultMessage: 'Pour cette demande, je m’engage au nom de tous les titulaires du bail, et ce congé est donc adressé au nom et pour le compte de l\'ensemble des titulaires',
		description: 'Has copreneurs radio button'
	})

	const arrayChoices: Array<string> = [choice1, choice2]
	const arrayIsStandalone: Array<string> = [isAlone, hasCopreneurs]
	const [preValue, setPreValue] = React.useState('')
	const [value, setValue] = React.useState('')
	const [joursFeries, setJoursFeries] = useState<string[]>([])
	const dispatch = useDispatch()

	// Les jours fériés ne bloquent le calendrier que côté résidence.
	// En cas d'échec de l'appel, seuls les week-ends restent bloqués : le parcours doit rester utilisable.
	useEffect(
		() => {
			if (process.env.REACT_APP_TARGET !== portals.campus) {
				getJoursFeries()
					.then((response: any) => setJoursFeries(Object.values(response)))
					.catch(() => setJoursFeries([]))
			}
		},
		[]
	)

	const initChoices = useMemo(() => [
		{
			weekDay: defaultDate,
			timeSlot: defaultTimeSlot
		},
		{
			weekDay: defaultDate,
			timeSlot: defaultTimeSlot
		},
		{
			weekDay: defaultDate,
			timeSlot: defaultTimeSlot
		}
	], [defaultDate, defaultTimeSlot])

	const initialValues = useMemo(() => ({
		phone: user.phone,
		preDateChoices: initChoices,
		dateChoices: initChoices
	}), [initChoices, user.phone])

	const contractHasColocataire = () => {
		if (Array.isArray(request.contract)) {
			return request.contract.filter((contract) => contract.interlocuteursRoleBail.filter((interlocuteurRoleBail) => interlocuteurRoleBail.eft_role === ROLE.COLOCATAIRE).length > 0).length > 0
		} else if (request.contract) {
			return request.contract.interlocuteursRoleBail.filter((interlocuteurRoleBail) => interlocuteurRoleBail.eft_role === ROLE.COLOCATAIRE).length > 0
		}

		return false
	}

	const validate = (values: SpecificationsDepositModel) => {
		const errors: any = {}

		if (!values.leaveDate || values.leaveDate.length === 0) {
			errors.leaveDate = intl.formatMessage(
				{
					id: 'global.errors.required',
					defaultMessage: 'Requis*',
					description: 'Required message'
				}
			)
		}
		if (!values.phone || values.phone.length === 0) {
			errors.phone = intl.formatMessage(
				{
					id: 'global.errors.required',
					defaultMessage: 'Requis*',
					description: 'Required message'
				}
			)
		}
		if (!values.leaveReason || values.leaveReason.length === 0) {
			errors.leaveReason = intl.formatMessage(
				{
					id: 'global.errors.required',
					defaultMessage: 'Requis*',
					description: 'Required message'
				}
			)
		}
		if (process.env.REACT_APP_TARGET === portals.residence && process.env.REACT_APP_TARGET === portals.residence && contractHasColocataire() && (!values.standaloneStatus || values.standaloneStatus.length === 0)) {
			errors.standaloneStatus = intl.formatMessage(
				{
					id: 'global.errors.required',
					defaultMessage: 'Requis*',
					description: 'Required message'
				}
			)
		}
		if (process.env.REACT_APP_TARGET === portals.campus) {
			if (hasApartment() && !values.preChoicesOption) {
				errors.preChoicesOption = intl.formatMessage(
					{
						id: 'global.errors.required',
						defaultMessage: 'Requis*',
						description: 'Required message'
					}
				)
			}
			if (hasApartment() && !values.choicesOption) {
				errors.choicesOption = intl.formatMessage(
					{
						id: 'global.errors.required',
						defaultMessage: 'Requis*',
						description: 'Required message'
					}
				)
			}
			if (values.attachment && values.attachment.length > 0 && !values.allowYFCampus) {
				errors.allowYFCampus = intl.formatMessage(
					{
						id: 'requests.makeRequest.step4.deposit.rib.allow.error',
						defaultMessage: 'Vous devez autoriser YouFirst Campus à procéder au remboursement sur la base du RIB fourni',
						description: 'Must check box error'
					}
				)
			}
		}

		return errors
	}

	const requiredArray = (values: DateChoiceModel[]) => {
		const errors: any = {}
		if (values) {
			values.forEach((dateChoice, index) => {
				if (index < 2) {
					if (dateChoice.timeSlot === defaultTimeSlot || dateChoice.weekDay === defaultDate) {
						errors[index] = { timeSlot: '', weekDay: '' }
						if (dateChoice.timeSlot === defaultTimeSlot) {
							errors[index].timeSlot = intl.formatMessage(
								{
									id: 'global.errors.required',
									defaultMessage: 'Requis*',
									description: 'Required message'
								}
							)
						}
						if (dateChoice.weekDay === defaultDate) {
							errors[index].weekDay = intl.formatMessage(
								{
									id: 'global.errors.required',
									defaultMessage: 'Requis*',
									description: 'Required message'
								}
							)
						}
					} else {
						if (values.some((value, i) => i !== index && value.weekDay === dateChoice.weekDay && value.timeSlot === dateChoice.timeSlot)) {
							errors[index] = { timeSlot: '', weekDay: '' }
							errors[index].timeSlot = intl.formatMessage(
								{
									id: 'global.errors.sameDateChoice',
									defaultMessage: 'Date et créneau déjà choisis',
									description: 'Already exist a same date message'
								}
							)
						}
					}
				}

			})
		}
		return errors
	}

	const onSubmit = (values: SpecificationsDepositModel) => {
		setLoading(true)

		if (values.preChoicesOption === choice1) {
			values.preChoicesOption = 'dates'
		} else {
			values.preChoicesOption = 'contacted'
		}
		if (values.choicesOption === choice1) {
			values.choicesOption = 'dates'
		} else {
			values.choicesOption = 'contacted'
		}

		if (process.env.REACT_APP_TARGET === portals.residence) {
			if (contractHasColocataire()) {
				values.isStandalone = values.standaloneStatus === isAlone
			} else {
				values.isStandalone = 'Seul'
			}
		}

        return fetchFactory(
            `/api/${intl.locale}/ec_${process.env.REACT_APP_TARGET}/demande/leaveDeposit`,
            {
                body: JSON.stringify({
                    ...values,
                    preDateChoices: JSON.stringify(values.preDateChoices),
                    dateChoices: JSON.stringify(values.dateChoices),
                    contract: request.contract
                }),
                method: configEnum.post
            }
        )
            .then(
                (response: any) => {
                    nextStep(response)
                }
            )
            .catch(
                (error) => {
                    if (!!error['content'] && !!error['content']['errorType']
                        && (error['content']['errorType'] === FormErrorEnum.DQE)
                    ) {
                        return {
                            phone: intl.formatMessage({
                                id: error['content']['id'],
                                defaultMessage: error['content']['defaultMessage'],
                                description: `Error during submission : ${error['content']['key']}`
                            }),
                            [FORM_ERROR]: intl.formatMessage({
                                id: error['content']['id'],
                                defaultMessage: error['content']['defaultMessage'],
                                description: `Error during submission : ${error['content']['key']}`
                            })
                        }
                    }
                    else {
                        dispatch(
                            displaySnackbar(
                                {
                                    id: COMPONENT_NAME,
                                    message: intl.formatMessage({
                                        id: `requests.makeRequest.step4.deposit.erreurs.${process.env.REACT_APP_TARGET}`,
                                        defaultMessage: 'Une erreur est survenue, veuillez contacter votre YouFirst Manager',
                                        description: 'Erreur générique'
                                    }),
                                    open: true,
                                    hideIcon: true
                                }
                            )
                        )
                    }
                }
            )
            .finally(
                () => {
                    setLoading(false)
                }
            )
    }

	const disableWeekends = (date: MaterialUiPickersDate) => date && (date.day() === 0 || date.day() === 6)

	const hasApartment = () => {
		if (Array.isArray(request.contract)) {
			return request.contract.filter((contract) => contract.type === 'apartment').length > 0
		}

		return request.contract?.type === 'apartment'
	}

	const checkLocation = (title: string, optionField: string, dateField: string, valueToCheck: string) => (
		<>
			<Grid container item xs={12}>
				<span className={informationClass}>
					<FormattedMessage
						id={title}
						defaultMessage="Vos préférences pour le rendez-vous de pré-état des lieux"
						description="Step 4 deposit preferences title"
					/>
				</span>
			</Grid>
			{
				optionField === formFieldsEnum.choicesOption && (
					<Grid container item xs={12} spacing={3}>
						<Grid container item xs={12} className={classes.text8}>
							<FormattedMessage
								id="requests.makeRequest.step4.deposit.checkLocationInfo"
								defaultMessage="La remise des clés se fait le jour de l’état des lieux de sortie."
								description="Check location info"
							/>
						</Grid>
					</Grid>
				)
			}

			<Grid container item xs={12}>
				<Field
					name={optionField}
					component={FormRadioField}
					items={arrayChoices.map((choice: string) => ({
						value: choice,
						label: choice
					}))}
					textStyle={isLargeScreen ? 'text1_opacity' : 'text2_opacity'}
					textColor="colorBlue"
					textWeight="medium"
					margin={false}
					type="radio"
					rowDirection={false}
				/>
				<OnChange name={optionField}>
					{(value: React.SetStateAction<string>, previous: any) => {
						if (optionField === formFieldsEnum.preChoicesOption) {
							setPreValue(value)
						} else {
							setValue(value)
						}
					}}
				</OnChange>
			</Grid>

			{
				valueToCheck === choice1 &&
				<Grid container item xs={12} className={classes.timeSlotContainer}>
					<FieldArray
						name={dateField}
						validate={requiredArray}
						render={
							(
								{
									fields,
									meta

								}
							) => (
								fields.map((name, index) => (
										<div key={name} className="row col-xs-12">
											<DateTimeSlotSelect
												name={name}
												errors={meta.error[index]}
												labelChoice={
													intl.formatMessage({
														id: `requests.makeRequest.step4.choice${index + 1}`,
														defaultMessage: `Choix ${index + 1}`,
														description: `choice${index + 1} option text`
													})
												}
												isLargeScreen={isLargeScreen}
											/>
										</div>
									)
								)
							)
						}
					/>
				</Grid>
			}
		</>
	)

	const checkContractsType = () => {
		if (Array.isArray(request.contract)) {
			if (request.contract.filter((contract) => contract.type === propertyType.apartment).length > 0 && request.contract.filter((contract) => contract.type === propertyType.garage).length > 0) {
				return { mapper: leaveReasonBothEnum, id: 'both' }
			}
			if (request.contract.filter((contract) => contract.type === propertyType.apartment).length > 0) {
				return { mapper: leaveReasonApartmentEnum, id: 'apartment' }
			}

			return { mapper: leaveReasonParkingEnum, id: 'parking' }
		}

		if (process.env.REACT_APP_TARGET === portals.campus) {
			return { mapper: leaveReasonCampusEnum, id: 'campus' }
		}

		if (Array.isArray(request.contract?.buildings)) {
			if (request.contract?.buildings && request.contract.buildings.filter((building) => building.nature === 221310000).length > 0 && request.contract.buildings.filter((contract) => contract.nature === 221310006).length > 0) {
				return { mapper: leaveReasonBothEnum, id: 'both' }
			}
		}

		if (request.contract?.type === propertyType.apartment) {
			return { mapper: leaveReasonApartmentEnum, id: 'apartment' }
		}

		return { mapper: leaveReasonParkingEnum, id: 'parking' }
	}

	const hasNoPrelevement = () => {
		if (Array.isArray(request.contract)) {
			return request.contract.filter(contract => contract.typeDePaiement !== PRL_AUTO && contract.typeDePaiement !== TIP).length === 0
		}

		return request.contract?.typeDePaiement !== PRL_AUTO && request.contract?.typeDePaiement !== TIP
	}

	const hasBailCodeCivil = () => {
		const contracts = Array.isArray(request.contract) ? request.contract : request.contract ? [request.contract] : []

		return contracts.some(contract => contract.categorieJuridique !== null && categoriesJuridiquesCodeCivil.includes(contract.categorieJuridique))
	}

	// Date de départ minimale : préavis de 3 mois pour un bail code civil, 1 mois sinon
	const getMinLeaveDate = () => {
		if (process.env.REACT_APP_TARGET === portals.campus) {
			return getToday()
		}

		return getNextAvailableDay(moment().add(hasBailCodeCivil() ? 3 : 1, 'month').format('YYYY-MM-DD'), joursFeries)
	}

	return (
		<Grid container item xs={12}>
			<Grid container item xs={12} className={mainInformationClass}>
				<span>
					<FormattedMessage
						id={`requests.makeRequest.step4.deposit.${process.env.REACT_APP_TARGET === portals.campus ? 'info_campus' : 'info_resi'}.title`}
						defaultMessage="Chez YouFirst, nous voulons simplifier votre quotidien, même quand vous nous dîtes au revoir. Pour nous notifier votre départ, nous vous proposons un parcours rapide et 100% digital, y compris pour les étapes légales."
						description="Make request step 4, leave deposit informations"
						values={{
							strong: (chunk: string) => <strong>{chunk}</strong>
						}}
					/>
				</span>
				<ul>
					<li>
						<FormattedMessage
							id={`requests.makeRequest.step4.deposit.${process.env.REACT_APP_TARGET === portals.campus ? 'info_campus' : 'info_resi'}.first`}
							defaultMessage="Vous déposez votre demande de résiliation du bail sur votre Espace client :"
							description="Make request step 4, leave deposit informations first bullet"
						/>
					</li>

					<ol>
						<li>
							<FormattedMessage
								id={`requests.makeRequest.step4.deposit.${process.env.REACT_APP_TARGET === portals.campus ? 'info_campus' : 'info_resi'}.second`}
								defaultMessage="Vous renseignez le formulaire ci-dessous avec les informations relatives à votre demande de résiliation."
								description="Make request step 4, leave deposit informations second bullet"
							/>
						</li>
						<li>
							<FormattedMessage
								id={`requests.makeRequest.step4.deposit.${process.env.REACT_APP_TARGET === portals.campus ? 'info_campus' : 'info_resi'}.formalize`}
								defaultMessage="Nous formalisons votre demande de résiliation du bail avec les informations renseignées."
								description="Make request step X, leave deposit informations X bullet"
							/>
						</li>
						<li>
							<FormattedMessage
								id={`requests.makeRequest.step4.deposit.${process.env.REACT_APP_TARGET === portals.campus ? 'info_campus' : 'info_resi'}.third`}
								defaultMessage="Vous signez cette demande électroniquement via la plateforme de signature sécurisée YouSign."
								description="Make request step 4, leave deposit informations third bullet"
							/>
						</li>
					</ol>

					<li>
						<FormattedMessage
							id={`requests.makeRequest.step4.deposit.${process.env.REACT_APP_TARGET === portals.campus ? 'info_campus' : 'info_resi'}.fourth`}
							defaultMessage="C’est fini : vous avez donné votre congé en respectant toutes les formalités. Votre préavis d’un mois démarre à la signature. Pas de fastidieux courrier recommandé avec accusé de réception : vous pouvez vous consacrer à vos cartons."
							description="Make request step 4, leave deposit informations fourth bullet"
							values={{
								strong: (chunk: string) => <strong>{chunk}</strong>
							}}
						/>
					</li>
					<li>
						<FormattedMessage
							id={`requests.makeRequest.step4.deposit.${process.env.REACT_APP_TARGET === portals.campus ? 'info_campus' : 'info_resi'}.five`}
							defaultMessage="Après la signature de votre demande de résiliation, veuillez attendre quelques minutes avant de voir votre demande s’afficher sur votre espace personnel."
							description="Make request step 4, leave deposit informations fifth bullet"
						/>
					</li>
				</ul>
			</Grid>

            <Form
                mutators={{
                    ...arrayMutators
                }}
                onSubmit={onSubmit}
                initialValues={initialValues}
                validate={validate}
                render={
                    (
                        {
                            handleSubmit,
                            submitError
                        }
                    ) => (
                        <form
                            onSubmit={handleSubmit}
                            className={classes.formStyle}
                        >
                            <Grid container item xs={12} spacing={3}>
                                {
                                    process.env.REACT_APP_TARGET === portals.campus && (
                                        <Grid container item xs={12} spacing={3}>
                                            <Grid container item xs={12} md={6}>
                                                <p className={classes.text8}>
                                                    <FormattedMessage
                                                        id="requests.makeRequest.step4.deposit.date.info"
                                                        defaultMessage="Le préavis légal est d’un mois. Si vous choisissez une date de départ avant, le loyer est dû jusqu’à la fin du préavis"
                                                        description="Leave date info"
                                                    />
                                                </p>
                                            </Grid>
                                        </Grid>
                                    )
                                }

								<Grid container item xs={12} md={6}>
									<span className={commonLabel}>
										<FormattedMessage
											id="requests.makeRequest.step4.deposit.date.label"
											defaultMessage="Date de départ souhaitée"
											description="Leave date field"
										/> *
									</span>

									<Field
										name={formFieldsEnum.leaveDate}
										type="date"
										component={FormDatePickerField}
										inputTextStyle={classes.dateText}
										disableToolbar={false}
										isGreyBackground={false}
										selectFuture={true}
										setMinDate={getMinLeaveDate()}
										setMaxDate={getNextYearDate()}
										dateToDisable={(date: MaterialUiPickersDate) => process.env.REACT_APP_TARGET === portals.campus ? disableWeekends(date) : shouldBlockCalendarDay(date, joursFeries)}
									/>
								</Grid>

								<Grid container item xs={12} md={6}>
									<Field
										name={formFieldsEnum.phone}
										component={FormPhoneField}
										id={formFieldsEnum.phone}
										label={
											`${intl.formatMessage(
												{
													id: 'requests.makeRequest.step4.deposit.phone',
													defaultMessage: 'Numéro de téléphone mobile',
													description: 'Phone label'
												}
											)} *`
										}
									/>
								</Grid>

								{
									process.env.REACT_APP_TARGET === portals.campus && hasApartment() && (
										<>
											{checkLocation('requests.makeRequest.step4.deposit.preCheckLocation', formFieldsEnum.preChoicesOption, formFieldsEnum.preDateChoices, preValue)}
											{checkLocation('requests.makeRequest.step4.deposit.checkLocation', formFieldsEnum.choicesOption, formFieldsEnum.dateChoices, value)}
										</>
									)
								}

								{
									process.env.REACT_APP_TARGET === portals.residence && contractHasColocataire() && (
										<>
											<Grid container item xs={12}>
												<span className={commonLabel}>
													<FormattedMessage
														id="requests.makeRequest.step4.deposit.isStandalone"
														defaultMessage="Dépôt de congé individuel ou collectif"
														description="Is standalone label"
													/> *
												</span>

												<Field
													name={formFieldsEnum.standaloneStatus}
													component={FormRadioField}
													items={arrayIsStandalone.map((choice: string) => ({
														value: choice,
														label: choice
													}))}
													textStyle={isLargeScreen ? 'text1_opacity' : 'text2_opacity'}
													textColor="colorBlue"
													textWeight="medium"
													margin={false}
													type="radio"
													rowDirection={false}
												/>
											</Grid>
										</>
									)
								}

								<Grid container item xs={12} direction="column" alignItems="flex-start">
									<span className={commonLabel}>
										<FormattedMessage
											id="requests.makeRequest.step4.deposit.leaveReason.label"
											defaultMessage="Motif de départ"
											description="Leave reason label"
										/> *
								    </span>

									<Field
										initialValue=""
										name={formFieldsEnum.leaveReason}
										component={FormSelectField}
										inputTextStyle={inputText}
										backgroundColor={selectColorEnum.grey}
										size={isLargeScreen ? selectSizeEnum.big : selectSizeEnum.small}
									>
										<MenuItem
											value=""
											className={textSelect}
											disabled
										>
											<FormattedMessage
												id="global.fields.select.default"
												defaultMessage="Choisir"
												description="Select default choice"
											/>
										</MenuItem>

										{
											Object.keys(checkContractsType().mapper).filter((reason) => isNaN(Number(reason))).map((reason: string) =>
												<MenuItem
													key={reason}
													value={checkContractsType().mapper[reason as any]}
													className={textSelect}
												>
													<FormattedMessage
														id={`requests.makeRequest.step4.deposit.leaveReason.${checkContractsType().id}.${reason}`}
														defaultMessage={reason}
														description={`${reason} leave reason`}
													/>
												</MenuItem>
											)
										}
									</Field>
								</Grid>

								<Grid container item xs={12}>
									<Field
										name={formFieldsEnum.comment}
										component={FormTextField}
										id={formFieldsEnum.comment}
										label={
											intl.formatMessage(
												{
													id: 'requests.makeRequest.step4.deposit.comment',
													defaultMessage: 'Commentaire',
													description: 'Comment field'
												}
											)
										}
										multiple
									/>
								</Grid>

								{
									(process.env.REACT_APP_TARGET === portals.campus || (process.env.REACT_APP_TARGET === portals.residence && hasNoPrelevement())) && (
										<>
											<Grid container item xs={12}>
												<span className={informationClass}>
													<FormattedMessage
														id="requests.makeRequest.step4.deposit.rib.info"
														defaultMessage="Afin de procéder au remboursement de votre dépôt de garantie, le cas échéant, nous vous invitons à ajouter votre RIB en pièce jointe."
														description="Rib information label"
													/>
												</span>
											</Grid>

											<Grid container item xs={12}>
												<FieldArray
													name={formFieldsEnum.attachment}
													render={
														(
															{
																fields,
																meta
															}
														) => (
															<FormFile
																fields={fields}
																meta={meta}
																label={
																	<FormattedMessage
																		id="requests.makeRequest.step4.deposit.rib.attachment"
																		defaultMessage="Ajouter un RIB"
																		description="Input placeholder"
																	/>
																}
																id={formFieldsEnum.attachment}
															/>
														)
													}
												/>
											</Grid>

											{
												process.env.REACT_APP_TARGET === portals.campus && (
													<Grid container item xs={12}>
														<Field
															name={formFieldsEnum.allowYFCampus}
															component={CheckBoxField}
															type="checkbox"
															label={
																intl.formatMessage(
																	{
																		id: 'requests.makeRequest.step4.deposit.rib.allow.label',
																		defaultMessage: 'J’autorise YouFirst Campus à procéder au remboursement de mon dépôt de garantie sur le compte du titulaire mentionné en pièce jointe',
																		description: 'Allow YouFirst label'
																	}
																)
															}
															textStyle="text4"
														/>
													</Grid>
												)
											}
										</>
									)
								}


                                <Grid container item className={classes.buttonContainer}>
                                    {submitError && <Grid xs={12} item container className={errorClass}>{submitError}</Grid>}
                                    <Grid container item xs={12} md={4}>
                                        {
                                            loading ? (
                                                <Loader />
                                            ) : (
                                                <Button
                                                    background="backgroundAccessibility"
                                                    color="colorWhite"
                                                    textStyle="text8"
                                                    type="submit"
                                                    size="bigButton"
                                                >
                                                    <FormattedMessage
                                                        id="requests.makeRequest.step4.deposit.submit"
                                                        defaultMessage="Continuer votre demande"
                                                        description="Submit message"
                                                    />
                                                </Button>
                                            )
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    )
                }
            />
        </Grid>
    )
}

const mapDispatchToProps = (dispatch: Dispatch<any>) => (
	{
		errorCatcher: (error: any, id: string) => {
			dispatch(errorCatcher(error, id))
		}
	}
)

export default connect(null, mapDispatchToProps)(RequestSpecificationsDeposit)
